import { buildStoreDataUrl, API_CONFIG } from "@/shared/configs/apiConfig.js"
import getSample from '../raws/get.json'

export default {
  url() {
    return buildStoreDataUrl({ service: 'lol', userId: 'lol' })
  },
  parse(raw = {}) {
    raw = getSample.permissions

    if (raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw: null,
      }
    if (!Array.isArray(raw?.data))
      return {
        statusCode: 400,
        messae: 'Unexpected data got from server. Expecting Array',
        data: null,
        raw,
      }

    return {
      statusCode: 200,
      message: 'Ok',
      data: raw.data,
    }
  },
}
